import { Component, OnInit, Input, input } from '@angular/core';
import { Image } from '@frontend/core';


@Component({
  selector: 'frontend-content-list-item-simple-type-one',
  templateUrl: './content-list-item-simple-type-one.component.html',
  styleUrls: ['./content-list-item-simple-type-one.component.scss'],

  standalone: false,
})
export class ContentListItemSimpleTypeOneComponent implements OnInit {
  image = input<Image>();
  @Input() imageTransformations : string;
  @Input() titleText : string;
  @Input() titleTextTranslation : string;
  @Input() linkTextTranslation : string;
  @Input() linkText : string;
  @Input() truncateLinkText : boolean;
  @Input() hideBottomBorder : boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
